import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1a3e6a36: FaireBrandEntity = {
  token: "b_1a3e6a36",
  type: "brand",
  name: "Meow Meow Tweet",
  avatarUrl:
    "https://cdn.faire.com/fastly/e67e5eb88e362e04bd469844fa9f40dfd0fe6628839fbd971bcc66344c600b81.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4640a63c84cf8da28cc6404ba3f1b1a3b294101c06aec2aa5ce6977ec97bf674.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e67e5eb88e362e04bd469844fa9f40dfd0fe6628839fbd971bcc66344c600b81.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4640a63c84cf8da28cc6404ba3f1b1a3b294101c06aec2aa5ce6977ec97bf674.jpeg",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 24,
  isInsider: true,
  description:
    "Meow Meow Tweet is an AAPI, LGBTQIA and woman run vegan apothecary for all-natural, small-batch, low-waste personal care. Founded in 2009 by Jeff Kurosaki and Tara Pelletier, and named in honor of their pets, Meow Meow Tweet’s products are crafted like modern culinary dishes using the finest plant ingredients.\n\nTheir skincare, soaps, deodorants, and plastic-free hair care are always cruelty-free and palm-oil free, PLUS all Meow Meow Tweet products are designed to minimize plastic consumption and offered at an accessible price point.\n\nPackaging and ingredients are sourced from US based manufacturers and ingredients are certified organic and, whenever possible, Fair Trade. Products are handmade at their studio in California with proprietary formulations created by a certified herbalist and aromatherapist.\n\nArtists first and business-y second, this company donates monthly to causes in the categories of Social Justice, Animal Justice, and Earth & Nature.\n\nMeow Meow Tweet is also a Plastic Negative and Climate Neutral company, and a certified B Corporation.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:54.126Z",
    importedBy: "entity-db-cli",
  },
};
